import { Creator } from "../../../api/staff";

export const getCreatorsTableColumns = (t: (key: string) => string) => [
  { key: "id", name: t("admin.creators.columns.id"), sortable: false },
  { key: "name", name: t("admin.creators.columns.name"), sortable: true, sortKey: "name" },
  { key: "email", name: t("admin.creators.columns.email"), sortable: false },
  { key: "status", name: t("admin.creators.columns.status"), sortable: false },
  { key: "balance", name: t("admin.creators.columns.balance"), sortable: false },
  { key: "created_at", name: t("admin.creators.columns.createdAt"), sortable: true, sortKey: "created_at" },
  { key: "actions", name: "", sortable: false }
];

const CREATOR_STATUS_COLORS: Record<Creator["status"], string> = {
  active: "#17C964",
  wait_confirm: "#F5A524",
  wait_moderation: "#7828C8",
  deactivated: "#F31260",
  wait_first_deposit: "#17A2B8"
};

export const getCreatorStatusConfig = (
  status: Creator["status"],
  t: (key: string) => string
) => {
  const color = CREATOR_STATUS_COLORS[status] || "#71717A";

  const labelKeyMap: Record<Creator["status"], string> = {
    active: "admin.creators.status.active",
    wait_confirm: "admin.creators.status.waitConfirm",
    wait_moderation: "admin.creators.status.waitModeration",
    deactivated: "admin.creators.status.deactivated",
    wait_first_deposit: "admin.creators.status.waitFirstDeposit"
  };

  const label =
    labelKeyMap[status] ? t(labelKeyMap[status]) : status;

  return {
    label,
    color
  };
};

const CREATOR_LEVEL_COLORS: Record<Creator["lvl"], string> = {
  bronze: "#CD7F32",
  silver: "#71717A",
  gold: "#F5A524",
  platinum: "#18181B",
  diamond: "#B9F2FF"
};

export const getCreatorLevelConfig = (
  level: Creator["lvl"],
  t: (key: string) => string
) => {
  const color = CREATOR_LEVEL_COLORS[level] || "#F4F4F5";

  // Capitalize first letter for display
  const label = level.charAt(0).toUpperCase() + level.slice(1);

  return {
    label,
    color
  };
};
